import { useNavigate } from 'react-router';
import { useUi } from '@/lib/store';
import { watchPathFor } from '@/lib/watch';
import { Dialog } from '../ui/dialog';
import { StreamChooser, StreamCount } from './stream-chooser';

export function StreamSelectionModal() {
  const target = useUi((s) => s.streamTarget);
  const close = useUi((s) => s.closeStreams);
  const navigate = useNavigate();
  return (
    <Dialog
      open={!!target}
      onOpenChange={(o) => !o && close()}
      size="2xl"
      title="Choose Your Stream"
      description={
        target && (
          <>
            {target.title}
            {target.season != null && ` · S${target.season} E${target.episode}`}
            {target.episodeTitle && ` · ${target.episodeTitle}`}
            <StreamCount target={target} />
          </>
        )
      }
    >
      {target && (
        <StreamChooser
          key={`${target.mediaId}:${target.season}:${target.episode}`}
          target={target}
          onLeave={close}
          onReady={(session) => {
            close();
            const qs = new URLSearchParams({
              session: session.id,
              ...(target.restart ? { restart: '1' } : {}),
            });
            navigate(
              `${watchPathFor(target.type, target.mediaId, target.season, target.episode)}?${qs}`,
              {
                state: { target, session },
              },
            );
          }}
        />
      )}
    </Dialog>
  );
}
